import { BROADCAST_END_ALLOWANCE_TIME, RECORDING_STUDIO_STATE } from '@/constants';
import { Broadcast } from '@/store/modules/event/types';
import { timeDiff } from '@/utils/dateTime';

interface StageAccessParams {
  broadcastDetails: Broadcast;
  event?: any;
  currentTime?: Date;
  useRecordingPlayPause?: boolean;
}

export function isStageAccessibleToAttendee({
  broadcastDetails,
  event,
  currentTime = new Date(),
  useRecordingPlayPause = false
}: StageAccessParams): boolean {
  const isLiveHybrid = broadcastDetails.broadcast_type === 'LIVE_HYBRID';
  const isSimulive = broadcastDetails.broadcast_type === 'SIMULIVE';

  if (event?.event_type === 'Recording') {
    if (broadcastDetails.recording_studio_state === RECORDING_STUDIO_STATE.RECORDING) {
      return true;
    }
    return false;
  }

  if (useRecordingPlayPause) {
    return broadcastDetails.recording_studio_state === RECORDING_STUDIO_STATE.RECORDING;
  }

  if (broadcastDetails.is_live) {
    return true;
  }

  if (event?.manual_redirection_enabled) {
    return false;
  }

  if (isSimulive) {
    return broadcastDetails.is_live;
  }

  const currentBroadcastStartTime = broadcastDetails?.start_time ? new Date(broadcastDetails.start_time) : new Date();

  const hasStartTimePassed = currentTime.getTime() > currentBroadcastStartTime.getTime();

  if (hasStartTimePassed) {
    const timeSinceEnd = timeDiff(broadcastDetails.end_time, currentTime);

    if (isLiveHybrid && timeSinceEnd < BROADCAST_END_ALLOWANCE_TIME) {
      return true;
    }

    if (timeSinceEnd < 0) {
      return true;
    }
  }

  return false;
}
